import React from "react";
import Script from 'react-load-script';

const GoogleAnalytics = () => {
  if (process.env.REACT_APP_ENV === 'sit') {
    console.log("Loading GA - SIT...");
    return <Script
      url="https://www.googletagmanager.com/gtag/js?id=UA-163672268-1"
      onLoad={() => {
        window.dataLayer = window.dataLayer || [];
        // eslint-disable-next-line no-undef
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'UA-163672268-1');
      }}
    />;
  } else if (process.env.REACT_APP_ENV === 'uat') {
    console.log("Loading GA - UAT...");
    return <Script
      url="https://www.googletagmanager.com/gtag/js?id=UA-163672268-2"
      onLoad={() => {
        window.dataLayer = window.dataLayer || [];
        // eslint-disable-next-line no-undef
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'UA-163672268-2');
      }}
    />;
  } else if(process.env.REACT_APP_ENV === 'prod') {
    console.log("Loading GA...");
    return <Script
      url="https://www.googletagmanager.com/gtag/js?id=UA-163672268-3"
      onLoad={() => {
        window.dataLayer = window.dataLayer || [];
        // eslint-disable-next-line no-undef
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'UA-163672268-3');
      }}
    />
  } else {
    console.log("Not loading GA...");
  }
}

export default GoogleAnalytics;
